import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=191f45f9&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191f45f9')) {
      api.createRecord('191f45f9', component.options)
    } else {
      api.reload('191f45f9', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=191f45f9&", function () {
      api.rerender('191f45f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iFucYBrI3F5P/JS/videoIframe.vue"
export default component.exports